var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.83331V20.1666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.16663H7.91667C7.14312 5.16663 6.40125 5.47392 5.85427 6.0209C5.30729 6.56788 5 7.30974 5 8.08329C5 8.85684 5.30729 9.59871 5.85427 10.1457C6.40125 10.6927 7.14312 11 7.91667 11H12.0833C12.8569 11 13.5987 11.3073 14.1457 11.8542C14.6927 12.4012 15 13.1431 15 13.9166C15 14.6902 14.6927 15.432 14.1457 15.979C13.5987 16.526 12.8569 16.8333 12.0833 16.8333H5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.fade98fa19034b2a07e578b8fcbc8f6d.svg";
export { ForwardRef as ReactComponent };